import {DefaultContext} from '../../utils/types';
import React from 'react';
import {State} from '../types/NSCItemScanner';
export const initialState: State = {
  barcodes: [],
  buyers: [],
  item: undefined,
};

const defaultVal: DefaultContext<State> = {
  state: initialState,
  dispatch: null,
};

export const NSCItemScannerContext = React.createContext(defaultVal);
